<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/" class="linkstyle">展覽列表</a
          ><span>/</span> <em name="Exhibition"></em> <span>/</span>展昭展覽APP
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft mt-5">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo">
            <img :src="ExhLogo" width="100%" />
          </div>

          <div class="expoInfo">
            <p class="bold" name="Exhibition">{{ ExhibitionName }}</p>
            <p>{{ Exhdate }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>

      <div class="contentBox">
        <!-- left -->
        <div class="proLeft NoShowInMobile align_c">
          <img src="@/assets/images/ccat.png" width="100%" />
        </div>
        <!-- left end -->
        <!-- right -->
        <div class="proRight">
          <div class="MbDevice">
            <div class="d-flex align-items-center">
              <div>
                <img
                  src="@/assets/images/ccat.png"
                  width="35px"
                  class="mt-1 mr-1"
                />
              </div>
              <div>
                <h1>展昭展覽 EXPO APP</h1>
              </div>
            </div>
          </div>
          <div class="PcDevice">
            <h1>展昭展覽 EXPO APP</h1>
          </div>

          <p class="my-3">&nbsp;</p>
          <p>買主資料即時Get全面升級！註冊會員免費使用！</p>
          <p class="my-3">&nbsp;</p>
          <ol>
            <li>
              僅需註冊個人會員，即可使用免費個人化電子名片，可記錄及收藏更多買主資訊。
            </li>

            <li>
              參展商免費上傳產品以及廠商資訊，可於各展官網以及展昭APP露出，
              未來可參與專屬參展商活動，與參觀者有更多互動以及被收藏的機會。

              <p class="red mt-1">
                (請務必傳上資訊，才可於互動平面圖上進行露出增加參觀者收藏的機會)
              </p>
            </li>
          </ol>

          <p class="lightLine">&nbsp;</p>

          <h3>APP功能介紹</h3>
          <p class="my-4">&nbsp;</p>

          <h2 class="mb-1 AppIntrofont red">個人電子名片</h2>

          <p>展覽廠商，客戶數位名片，輕鬆一掃，快速留存資料。</p>
          <p class="my-3">&nbsp;</p>
          <h2 class="mb-2 AppIntrofont red">互動數位平面圖</h2>

          <p>可搜尋興趣廠商及產品之攤位，於平面圖上同步顯示以利引導方向。</p>

          <p class="my-3">&nbsp;</p>

          <h2 class="mb-2 AppIntrofont red">廠商及新品收藏</h2>

          <p>收藏產業第一手資訊，協助專業買主資料蒐集。</p>
          <p class="my-3">&nbsp;</p>
          <h2 class="mb-2 AppIntrofont red">參觀筆記</h2>

          <p>可文字、語音、拍照紀錄觀展重點，重要訊息不遺漏。</p>
          <p class="my-3">&nbsp;</p>

          <h2 class="mb-2 AppIntrofont red">快速入場</h2>

          <p>索取入場憑證後，可快速出示Qrcode入場。</p>

          <p class="lightLine">&nbsp;</p>
          <h3>立刻下載【展昭展覽】EXPO APP</h3>
          <p class="my-3">&nbsp;</p>

          <div class="row align-items-center">
            <div class="col-md-2 col-4">
              <img
                src="https://www.chanchao.com.tw/images/event/ccapp_ios.jpg"
                class="img-fluid"
              />
            </div>
            <div class="col-md-2 col-4">
              <img
                src="https://www.chanchao.com.tw/images/event/ccapp_android.jpg"
                class="img-fluid"
              />
            </div>
            <div class="col-md-2 col-4">
              <img
                src="https://www.chanchao.com.tw/images/event/ccapp_apk.jpg"
                class="img-fluid"
              />
            </div>
          </div>
          <p class="my-3">&nbsp;</p>

          APP下載連結:

          <a
            target="_blank"
            class="linkstyle"
            href="https://apps.apple.com/tw/app/%E5%B1%95%E6%98%AD%E5%B1%95%E8%A6%BD-chan-chao-expo/id6448909182"
          >
            IOS
          </a>
          /
          <a
            target="_blank"
            class="linkstyle"
            href="https://play.google.com/store/apps/details?id=com.chanchaoofficialapp"
          >
            Android
          </a>
          /
          <a
            target="_blank"
            class="linkstyle"
            href="https://www.chanchao.com.tw/downloads/chanchao-app/chan-chao-expo-app-release.zip"
          >
            APK
          </a>

          <p class="my-3">&nbsp;</p>
          獲得更多資訊 :
          <a
            target="_blank"
            class="linkstyle"
            href="https://www.chanchao.com.tw/memberExpoApp.asp"
          >
            https://www.chanchao.com.tw/memberExpoApp.asp
          </a>
        </div>
        <p class="clear"></p>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  components: {},

  metaInfo() {
    return {
      title: "展昭展覽 EXPO APP - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      Exhdate: "",
      ExhVenue: "",
      ExhibitionName: "",
      UserId: "",
      RegNo: "",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      VisitorGetQuota: "",
    };
  },

  methods: {},

  created() {
    const vm = this;

    let lang = "tw";

    //url取出展碼
    let nowPage = location.href;
    vm.RegNo = nowPage.split("no=")[1];

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${lang}`,
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
      });

    $(function () {
      let lang = "tw";
      $.getJSON(
        "/apiExhibitors/Exhibition/" + vm.RegNo,
        { lang: lang },
        function (data) {
          //exh detail
          $('[name="date"]').text(
            data.Data.ExhBegin + " - " + data.Data.ExhEnd,
          );

          //OpenDay
          var OpenDay = new Date(data.Data.ExhBegin);

          OpenDay.setDate(OpenDay.getDate() - 1);
          $('[name="OpenDay"]').text(formatDate(OpenDay));

          function formatDate(date) {
            var d = new Date(date),
              month = "" + (d.getMonth() + 1),
              day = "" + d.getDate(),
              year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("/");
          }

          //close day
          var CloseDay = new Date(data.Data.ExhEnd);
          CloseDay.setDate(CloseDay.getDate() + 30);
          $('[name="CloseDay"]').text(formatDate(CloseDay));
        },
      );

      //contact info
      $.getJSON(
        "/apiExhibitors/AdvContact/" + vm.RegNo,
        { lang: lang },
        function (data) {
          $('[name="ExpoContact"]').html(data.Data.AdvContact);

          // console.log(data)
        },
      );
    });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //取得使用者數量限制
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        vm.VisitorGetQuota = response.data.Data.VisitorGetQuota;
      });
  },
};
</script>

<style lang="scss">
ol {
  display: block;
  margin: 0px 20px;
  padding: 0px;
}

.AppIntrofont {
  font-weight: 500;
  font-size: 16px;
}
</style>
